// extracted by mini-css-extract-plugin
export default {"clock-header":"clock_clock-header__qd52r","timer":"clock_timer__q5X9P","clockContainer":"clock_clockContainer__wTUEe"};